// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rh272bKyfVkP8onJ3P9k {
    position: fixed;
    background: white;
    width: 80%;
    max-width: 55vw;
    height: 80vh;
    overflow: hidden;
    right: 20px;
    bottom: 3px;
    border: #5db7c8;
    border-radius: 3px;
    border-style: solid;
    box-shadow: #00000012 -4px 1px 20px 2px;
    z-index: 1101; 
}

@media only screen and (max-width: 800px) {
    .rh272bKyfVkP8onJ3P9k {
        width: initial;
        max-width: initial;
        height: initial;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border: none;
        border-radius: 0;
    }
}

.LB5aSERqeZwSoQ18brjU {
    position: absolute;
    right: 10px;
    top: 10px;
    color: black;
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile-slideout/components/slideout.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,MAAM;QACN,QAAQ;QACR,SAAS;QACT,OAAO;QACP,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,UAAU;AACd","sourcesContent":[".slideout {\n    position: fixed;\n    background: white;\n    width: 80%;\n    max-width: 55vw;\n    height: 80vh;\n    overflow: hidden;\n    right: 20px;\n    bottom: 3px;\n    border: #5db7c8;\n    border-radius: 3px;\n    border-style: solid;\n    box-shadow: #00000012 -4px 1px 20px 2px;\n    z-index: 1101; \n}\n\n@media only screen and (max-width: 800px) {\n    .slideout {\n        width: initial;\n        max-width: initial;\n        height: initial;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        border: none;\n        border-radius: 0;\n    }\n}\n\n.closeslideout {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    color: black;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slideout": `rh272bKyfVkP8onJ3P9k`,
	"closeslideout": `LB5aSERqeZwSoQ18brjU`
};
export default ___CSS_LOADER_EXPORT___;
